import { forwardRef } from 'react'
import type { LucideProps } from 'lucide-react'

/** Locked SoT for Open in new tab (open-destination-icons). */
export const AppWindowPlus = forwardRef<SVGSVGElement, LucideProps>(
  /** Renders the locked Open in new tab icon (window frame + plus). */
  function AppWindowPlus(
    {
      color = 'currentColor',
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth,
      className,
      ...props
    },
    ref,
  ) {
    const numericSize = typeof size === 'number' ? size : 24
    const numericStroke = typeof strokeWidth === 'number' ? strokeWidth : 2
    const computedStroke = absoluteStrokeWidth
      ? (numericStroke * 24) / numericSize
      : strokeWidth

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={computedStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
        {...props}
      >
        <rect width="20" height="16" x="2" y="4" rx="2" />
        <path d="M2 8h20" />
        <path d="M12 11v6" />
        <path d="M9 14h6" />
      </svg>
    )
  },
)

AppWindowPlus.displayName = 'AppWindowPlus'
